import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import PaymentMethodIcon from '../PaymentMethodIcon';
import { getIcon } from '../PaymentMethodIcon/PaymentMethodIcon.utils';
import { getDisplayablePaymentMethod } from '../checkout.utils';
import './PaymentMethodDisplay.css';
var defaultProps = {};
function PaymentMethodDisplay(_ref) {
  var last4 = _ref.last4,
    type = _ref.type;
  var iconAvailable = !_isEmpty(getIcon(type));
  return /*#__PURE__*/React.createElement("div", {
    className: "payment-method-display-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "type-display"
  }, iconAvailable ? /*#__PURE__*/React.createElement(PaymentMethodIcon, {
    type: type
  }) : /*#__PURE__*/React.createElement("b", null, getDisplayablePaymentMethod(type) || type)), /*#__PURE__*/React.createElement("p", null, "**** **** **** ", last4));
}
PaymentMethodDisplay.defaultProps = defaultProps;
export default PaymentMethodDisplay;